/* eslint-disable @typescript-eslint/no-explicit-any */
import { EAdmissionStages, IAdmissionStagesResponse } from '@src/constants/modals/admissions';
import { NodeType } from '@src/store/AdmissionStagesStore';
import languageKeys from "@src/localization/local.json";




export const getDescription = (step: IAdmissionStagesResponse, t: any) => {
  switch (step?.stage) {
    case EAdmissionStages.criteria_selection:
      return { description: step?.optional ? t(languageKeys.optional) : step?.status ? t(languageKeys.completed) : t(languageKeys.pending) };
    case EAdmissionStages.payment:
      return { description: step?.optional ? t(languageKeys.optional) : step?.status ? t(languageKeys.completed) : t(languageKeys.pending) };
    case EAdmissionStages.basic_details:
      return { description: step?.optional ? t(languageKeys.optional) : step?.status ? t(languageKeys.completed) : t(languageKeys.pending) };
    case EAdmissionStages.educational_details:
      return { description: step?.optional ? t(languageKeys.optional) : step?.status ? t(languageKeys.completed) : t(languageKeys.pending) };
    case EAdmissionStages.experience_professional:
      return { description: step?.optional ? t(languageKeys.optional) : step?.status ? t(languageKeys.completed) : t(languageKeys.pending) };
    case EAdmissionStages.statement_purpose:
      return { description: step?.optional ? t(languageKeys.optional) : step?.status ? t(languageKeys.completed) : t(languageKeys.pending) };
    case EAdmissionStages.upload_documents:
      return { description: step?.optional ? t(languageKeys.optional) : step?.status ? t(languageKeys.completed) : t(languageKeys.pending) };
    default:
      break;
  }
};
export const getStatus = (currentStatus: boolean, status: number, optional: number): string => {

  if (currentStatus && status == 0) {
    return 'process';
  } else if (status === 1 || optional === 1) {
    return 'finish';
  } else {
    return 'wait';
  }
};
export const getDisabled = (
  step: IAdmissionStagesResponse,
  admissionStagesResponse: any,
  currentApplicationData: boolean
) => {

  const selectionStage = admissionStagesResponse?.data?.find((s: any) => s.stage === EAdmissionStages.criteria_selection);
  const isCriteriaComplete = selectionStage?.status === 1;
  const paymentStage = admissionStagesResponse?.data?.find((s: any) => s.stage === EAdmissionStages.payment);
  const isPaymentComplete = paymentStage?.status === 1;
  const stagesTobeDisabled = [3, 4, 5].includes(step?.order);

  if (!currentApplicationData && stagesTobeDisabled) {
    return true;
  }

  if (!isCriteriaComplete) {
    return true;
  }
  if (isCriteriaComplete && !isPaymentComplete) {
    return step.stage !== EAdmissionStages.payment;
  }
  return step.order <= paymentStage.order;
};


export const getCurrentStepIndex = (steps: Array<any>): number => {
  if (steps.length) {
    const firstIncompleteIndex = steps?.findIndex(({ status, optional }) => status === 0 && optional === 0);
    return firstIncompleteIndex === -1 ? steps.length - 1 : firstIncompleteIndex;
  } else {
    return -1
  }

};
const keys = [
  "personalDetails",
  "markSheet10",
  "markSheet12",
  "graduationCertificate",
  "graduationMarksheet",
  "resume",
  "experienceLetter",
  "extra_document",
  'passportSizePhoto',
  'postGraduationMarksheet',
  'postGraduationCertificate'
];

function mapByEntityType(keys: any, items: any) {
  const mapped = keys.reduce((acc: any, key: any) => {
    acc[key] = [];
    return acc;
  }, {});

  items?.forEach((item: any) => {
    if (mapped?.hasOwnProperty(item.entityType)) {
      mapped[item.entityType].push(item);
    }
  });

  return mapped;
}


const defalutValues: { [key: number]: any } = {
  0: { fullName: "", email: "", programId: '', phone: "", countryCode: '+91' },
  1: { correspondencehouseno: '', correspondencepincode: '', correspondencecity: '', correspondencedistrict: '', correspondencestate: '', correspondencecountry: '' },
  2: {
    personal_details: {
      dob: "",
      gender: "",
      nationality: "",
      identityNumber: "",
      category: "",
      dap: null,
      ageGroup: null,
      parentName: null,
      apaarId: null,
      linkedinProfile: null,
      knowAboutProgram: "",
      totalWorkExperience: null,
      highestQualification: "",
      academicMetricType: "",
      academicMetricValue: null,
      examType: null,
      score: null,
      year: null,
      studentTypeIds: [],
    },
    user_address: [
      {
        address: "",
        pincode: "",
        city: "",
        district: null,
        state: "",
        country: "",
        addressType: "correspondence",
      },
      {
        address: "",
        pincode: "",
        city: "",
        district: null,
        state: "",
        country: "",
        addressType: "permanent",
      },
    ],
  },
  3: {
    school_education: [
      {
        standard: "10th",
        year: null,
        totalMarks: null,
        marksObtained: null,
        percentage: null,
        cpi: null,
      },
      {
        standard: "12th",
        year: null,
        totalMarks: null,
        marksObtained: null,
        percentage: null,
        cpi: null,
      },
    ],
    graduation: {
      degree: "",
      discipline: "",
      universityName: null,
      instituteName: null,
      year: null,
      marks: null,
      degreeLevel: "undergraduate"
    },
    post_graduation: [],
    users_research_publication: [],
  },
  4: {
    experience_professional: [{ organization: null, designation: null, role: null, payPerAnnum: null, from: null, to: null, employmentStatus: null, organizationType: null, natureOfOccupation: null, occupationalField: null }],
  },
  5: {
    statement_purpose: {
      statement: null,
    },
  },
  6: {
    personalDetails: [], markSheet10: [], markSheet12: [], graduationCertificate: [], graduationMarksheet: [],
    resume: [], experienceLetter: [], extra_document: [], passportSizePhoto: [], postGraduationCertificate: [], postGraduationMarksheet: []
  },
};

export const responseModified = (stepIndex: number, value: any) => {
  const defaultStepValues = defalutValues[stepIndex] || {};

  // If value is null or undefined, return the default values
  if (!value || Object.keys(value).length === 0) {
    return defaultStepValues;
  }

  // Merge default values with the provided value
  const mergedValues = { ...defaultStepValues };

  Object.keys(defaultStepValues).forEach((key) => {
    if (Array.isArray(defaultStepValues[key])) {
      // If the key is an array and the value is empty or undefined, set the default array
      mergedValues[key] = value[key]?.length ? value[key] : defaultStepValues[key];
    } else {
      // If the key is null or undefined, set the default value
      mergedValues[key] = value[key] ?? defaultStepValues[key];
    }
  });

  if (stepIndex < 6) {
    return mergedValues;
  } else {
    return mapByEntityType(keys, value);
  }
};


export const transformData = (data: any) => {
  const transformed: any = { programId: data.programId };

  Object.keys(data).forEach((key) => {
    if (key !== "programId") {
      transformed[key] = [{ fieldName: key, value: data[key] }];
    }
  });

  return transformed;
};

export const sortBySequenceRecursive = (items: any) => {
  return items
    .slice()
    .sort((a: any, b: any) => a.sequence - b.sequence)
    .map((item: any) => ({
      ...item,
      children: item.children && item.children.length
        ? sortBySequenceRecursive(item.children)
        : []
    }));
}



export type InputNode = {
  id: number;
  name: string;
  type: string;
  parent_id: number | null;
  children: InputNode[];
}

type OutputNode = {
  title: string;
  value: string;
  isLeaf: boolean;
  selectable: boolean;
  children?: OutputNode[];
}

export const transformTree = (data: NodeType[]): OutputNode[] => {
  return data.map((node): OutputNode => {
    const hasChildren = node.children && node.children.length > 0;

    return {
      title: node.name,
      value: String(node.id),
      isLeaf: !hasChildren,
      selectable: !hasChildren,
      children: hasChildren ? transformTree(node.children) : []
    };
  });
}

export const transformStatusListTree = (
  data: any,
  currentStatusId: any
) => {

  let currentSequence = 0;

  // Find effective sequence
  data.forEach((parent:any) => {

    // Parent selected
    if (parent.id === currentStatusId) {
      currentSequence = parent.sequence;
    }

    // Child selected → use parent sequence
    parent.children?.forEach((child: any) => {
      if (child.id === currentStatusId) {
        currentSequence = parent.sequence;
      }
    });

  });

  // Build tree
  return data.map((node:any) => {

    const hasChildren = node.children?.length > 0;

    const parentDisabled = node.sequence <= currentSequence;

    return {
      title: node.name,
      value: node.id,
      isLeaf: !hasChildren,
      selectable: !parentDisabled,
      disabled: parentDisabled,

      // Children follow parent state
      children: hasChildren
        ? node.children.map((child: any) => ({
          title: child.name,
          value: child.id,
          isLeaf: true,
          selectable: !parentDisabled,
          disabled: parentDisabled
        }))
        : []
    };
  });
};





export const activeStatusesList = (items: any[]): any[] => {
  return items
    .filter(item => item.active === 1)
    .map(item => ({
      ...item,
      children: item.children?.length
        ? activeStatusesList(item.children)
        : []
    }));
};

export const statusFlatMap = (
  items: any[],
  map: Record<number, string> = {},
  mapNameToId: Record<string, number> = {}
): any => {
  items.forEach(item => {
    map[item.id] = item.name;
    mapNameToId[item.name] = item.id
    if (item.children?.length) {
      delete map[item.id];
      delete mapNameToId[item.name]
      statusFlatMap(item.children, map, mapNameToId);
    }
  });

  return { map, mapNameToId };
};



export const formatTimestamp = (
  timestamp: number,
  formatType: "shortDate" | "longDate" | "shortDay" | "longDay" | "dateDay" | "iso" | "usDate" | "timeDate"
): string => {
  const date = new Date(
    timestamp.toString().length === 10 ? timestamp * 1000 : timestamp
  );

  const options: Record<string, Intl.DateTimeFormatOptions> = {
    shortDate: { day: "2-digit", month: "2-digit", year: "numeric" },
    longDate: { day: "numeric", month: "long", year: "numeric" },
    shortDay: { weekday: "short" },
    longDay: { weekday: "long" },
    dateDay: { weekday: "long", day: "numeric", month: "long", year: "numeric" },
    iso: { year: "numeric", month: "2-digit", day: "2-digit" },
    usDate: { month: "2-digit", day: "2-digit", year: "numeric" },
    timeDate: { hour: "2-digit", minute: "2-digit", hour12: true, day: "numeric", month: "long", year: "numeric" }
  };

  const formatter = new Intl.DateTimeFormat("en-US", options[formatType]);
  return formatter.format(date);
}

export const courseProgramFlatMap = (arr: NodeType[]): Record<number, string> => {
  let map: Record<number, string> = {};

  for (const item of arr) {
    if (item.parent_id !== null) {
      map[item.id] = item.name;
    }
    if (item.children && item.children.length > 0) {
      const childMap = courseProgramFlatMap(item.children);
      map = { ...map, ...childMap };
    }
  }

  return map;
};

